import React, {useState} from "react";

import {Modal} from "react-bootstrap";
import styles from './StatusPopup.module.scss';

import './StatusPopup.scss'

import x_icon from '../../assets/popup/x_icon.png';

import {ReactComponent as CloseIcon} from "../../assets/editors/close_icon_x.svg";

import error_icon from '../../assets/popup/error_icon.png';
import warning_icon from '../../assets/popup/warning_icon.png';
import vi_icon from '../../assets/popup/vi_icon.png';
import {OrangeButton} from "../../components/com/pagesTab/orangeBtn/OrangeButton";
import {List, ListItem} from "@mui/material";

export enum StatusPopupType {
    ERROR,
    INFO,
    NOTE,
    CONFIRM
}

interface IStatusPopup {
    type: StatusPopupType;
    title: string;
    subTitle: string;
    messages: string[] | undefined;
    show: boolean;
    handleClose: () => void;
    confirmOnClick?: React.MouseEventHandler<HTMLButtonElement>;
    settings?: any;
    targetItemsLength?: number;
}


const StatusPopup: React.FC<IStatusPopup> = (props) => {
    const getIconByType = (type: StatusPopupType) => {
        if (type === StatusPopupType.ERROR) {
            return error_icon
        } else if (type === StatusPopupType.INFO) {
            return warning_icon
        } else if (type === StatusPopupType.NOTE) {
            return vi_icon
        } else if (type === StatusPopupType.CONFIRM) {
            return vi_icon
        }
    }
    const [value, setValue] = useState('softDelete');

    const onChangeValue = (e: React.ChangeEvent<HTMLInputElement>) => {
        setValue(e.target.value);
    }
    const [isWithItems, setWithItems] = useState('withOutItems');

    const onChangeWithItems = (e: React.ChangeEvent<HTMLInputElement>) => {
        setWithItems(e.target.value);
    }

    const onDeletePromotion = () => {
        props.settings.confirmOnClick.deletePromosItemsFromFlyer(isWithItems === 'withItems')
    }
    const messagesToRender = props.messages && props.messages.length ? props.messages.map((message, index) => {
            return <ListItem disablePadding key={index}>{message}</ListItem>
        }
    ) : [];


    switch (props.settings.modalName) {
        case "confirmHardDelete":
            return (
                <Modal dialogClassName={styles.soft_hard_delete_popup_wrapper} show={props.show}
                       onHide={props.handleClose}>
                    <div className={styles.close_button_container}>
                        <div onClick={props.handleClose}>
                            <CloseIcon/>
                        </div>
                    </div>
                    <div className={styles.content_popup_container}>
                        <div>Are you sure you want to delete the Page(s)?</div>
                        <div className={styles.button_container}>
                            <div onClick={props.settings.confirmOnClick.onHardDeleteClick}>
                                <OrangeButton buttonName="Confirm"/>
                            </div>
                        </div>
                    </div>
                </Modal>
            )
        case "confirmHardDeleteFlyer":
            return (
                <Modal dialogClassName={styles.soft_hard_delete_popup_wrapper} show={props.show}
                       onHide={props.handleClose}>
                    <div className={styles.close_button_container}>
                        <div onClick={props.handleClose}>
                            <CloseIcon/>
                        </div>
                    </div>
                    <div className={styles.content_popup_container}>
                        <div>Are you sure you want to permanently delete the Flyer?</div>
                        <div className={styles.button_container}>
                            <div onClick={props.settings.confirmOnClick.onHardDeleteClick}>
                                <OrangeButton buttonName="Confirm"/>
                            </div>
                        </div>
                    </div>
                </Modal>
            )
        case "confirmHardDeleteFlipbook":
            return (
                <Modal dialogClassName={styles.soft_hard_delete_popup_wrapper} show={props.show}
                       onHide={props.handleClose}>
                    <div className={styles.close_button_container}>
                        <div onClick={props.handleClose}>
                            <CloseIcon/>
                        </div>
                    </div>
                    <div className={styles.content_popup_container}>
                        <div>Are you sure you want to permanently delete the Flipbook?</div>
                        <div className={styles.button_container}>
                            <div onClick={props.settings.confirmOnClick.onHardDeleteClick}>
                                <OrangeButton buttonName="Confirm"/>
                            </div>
                        </div>
                    </div>
                </Modal>
            )
        case "uploadImageToPage":
            return (
                <Modal dialogClassName={styles.soft_hard_delete_popup_wrapper} show={props.show}
                       onHide={props.handleClose}>
                    <div className={styles.close_button_container}>
                        <div onClick={props.handleClose}>
                            <CloseIcon/>
                        </div>
                    </div>
                    <div className={styles.content_popup_container}>
                        <div>Confirm overwrite of the current image?</div>
                        <div className={styles.button_container}>
                            <div onClick={props.settings.confirmOnClick.onUploadImage}>
                                <OrangeButton buttonName="Confirm"/>
                            </div>
                        </div>
                    </div>
                </Modal>
            )

        case "uploadPdfFileToFlipbook":
            return (
                <Modal dialogClassName={styles.soft_hard_delete_popup_wrapper} show={props.show}
                       onHide={props.handleClose}>
                    <div className={styles.close_button_container}>
                        <div onClick={props.handleClose}>
                            <CloseIcon/>
                        </div>
                    </div>
                    <div className={styles.content_popup_container}>
                        <div>Overwrite the existing one?</div>
                        <div className={styles.button_container}>
                            <div onClick={props.settings.confirmOnClick.uploadPdfFileToFlipbook}>
                                <OrangeButton buttonName="Confirm"/>
                            </div>
                        </div>
                    </div>
                </Modal>
            )

        case "confirmSoftOrHardDelete":
            return (
                <Modal dialogClassName={styles.soft_hard_delete_popup_wrapper} show={props.show}
                       onHide={props.handleClose}>
                    <div className={styles.close_button_container}>
                        <div onClick={props.handleClose}>
                            <CloseIcon/>
                        </div>
                    </div>
                    <div className={styles.content_popup_container}>
                        <div>What do you wish to Delete?</div>
                        <div className={styles.options_list}>
                            <ul>
                                <li>
                                    <input
                                        onChange={onChangeValue}
                                        checked={value === "softDelete"}
                                        type="radio" value="softDelete"/>
                                    <div>
                                        Delete Page Image, Keep Content
                                    </div>
                                </li>
                                <li>
                                    <input
                                        checked={value === "hardDelete"}
                                        onChange={onChangeValue}
                                        type="radio" value="hardDelete"/>
                                    <div>
                                        Delete Page and Content
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div className={styles.button_container}>
                            <div
                                onClick={value === "hardDelete" ? props.settings.confirmOnClick.onHardDeleteClick : props.settings.confirmOnClick.onSoftDeleteClick}>
                                <OrangeButton buttonName="Confirm"/>
                            </div>
                        </div>

                    </div>
                </Modal>
            )
        case "deletePromosFromFlyer":
            return (
                <Modal dialogClassName={styles.soft_hard_delete_popup_wrapper} show={props.show}
                       onHide={props.handleClose}>
                    <div className={styles.close_button_container}>
                        <div onClick={props.handleClose}>
                            <CloseIcon/>
                        </div>
                    </div>
                    <div className={styles.content_popup_container}>
                        <div>What do you wish to Delete?</div>
                        <div className={styles.options_list}>
                            <ul>
                                <li>
                                    <input
                                        onChange={onChangeWithItems}
                                        checked={isWithItems === "withOutItems"}
                                        type="radio" value="withOutItems"/>
                                    <div>
                                        Delete the Promotion, keep its items
                                    </div>
                                </li>
                                <li>
                                    <input
                                        checked={isWithItems === "withItems"}
                                        onChange={onChangeWithItems}
                                        type="radio" value="withItems"/>
                                    <div>
                                        Delete the Promotion and Delete its Items
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div className={styles.button_container}>
                            <div
                                onClick={onDeletePromotion}>
                                <OrangeButton buttonName="Confirm"/>
                            </div>
                        </div>
                    </div>
                </Modal>
            )
        case "deleteItemsFromFlyer":
            return (
                <Modal dialogClassName={styles.soft_hard_delete_popup_wrapper} show={props.show}
                       onHide={props.handleClose}>
                    <div className={styles.close_button_container}>
                        <div onClick={props.handleClose}>
                            <CloseIcon/>
                        </div>
                    </div>
                    <div className={styles.content_popup_container}>
                        <div>{props.targetItemsLength! > 1 ? 'Confirm Items Delete with all they contents and Images.' : 'Confirm Item Delete with all its content and Image.'}</div>
                        <div className={styles.button_container}>
                            <div onClick={props.settings.confirmOnClick.deletePromosItemsFromFlyer}>
                                <OrangeButton buttonName="Confirm"/>
                            </div>
                        </div>
                    </div>
                </Modal>
            )
        case "deleteFramesFromFlyer":
            return (
                <Modal dialogClassName={styles.soft_hard_delete_popup_wrapper} show={props.show}
                       onHide={props.handleClose}>
                    <div className={styles.close_button_container}>
                        <div onClick={props.handleClose}>
                            <CloseIcon/>
                        </div>
                    </div>
                    <div className={styles.content_popup_container}>
                        <div>Confirm delete of all flyers frames</div>
                        <div className={styles.button_container}>
                            <div onClick={props.settings.confirmOnClick.deleteFramesFromFlyer}>
                                <OrangeButton buttonName="Confirm"/>
                            </div>
                            <div onClick={props.handleClose}>
                                <OrangeButton buttonName="Cancel"/>
                            </div>
                        </div>
                    </div>
                </Modal>
            )
        default:
            return (
                <Modal
                    backdropClassName={`status_popup_backdrop`}
                    dialogClassName="status_popup" show={props.show} onHide={props.handleClose}>

                    <Modal.Body>

                        <div className="close_button_container">
                            <img src={x_icon} onClick={props.handleClose} alt="image"/>
                        </div>

                        <div className="editor_popup_icon_container">
                            <img src={getIconByType(props.type)} alt="image"/>
                            <span>{props.title}</span>
                        </div>

                        <div className="editor_popup_content">
                            <p>{props.subTitle}</p>
                            <List disablePadding>{messagesToRender}</List>
                        </div>
                    </Modal.Body>

                </Modal>
            )
    }
}

export default StatusPopup;